//Libs
import styled from "styled-components";
import { Switch as _Switch } from "antd";

const Switch = styled(_Switch)``;

export default Switch;
